import { Module } from 'vuex-smart-module';
import ConferencesActions from './actions';
import ConferencesGetters from './getters';
import ConferencesMutations from './mutations';
import ConferencesState from './state';

export default new Module({
  state: ConferencesState,
  mutations: ConferencesMutations,
  actions: ConferencesActions,
  getters: ConferencesGetters,
});
